import postAPI from './postAPI.js'

export default async function postUpdateStepStatus(body) {
    const data = await postAPI('taskinstances/steps/updatestatus', body);
    return data;
}
